import { BookOpen } from 'lucide-react'

import type { BookChatCitation } from '@/api/services/book-ai'

import { citationLabel } from './citation-label'

type Props = {
  citation: BookChatCitation
  onClick: () => void
  /** 表示名（省略時はページか章の名前） */
  label?: string
}

/** 回答の根拠にした本文へ移動するボタン（押すとその箇所を開く。本文の抜粋はツールチップで出す） */
export const CitationChip = ({ citation, onClick, label }: Props) => (
  <button
    type="button"
    title={citation.excerpt}
    className="flex max-w-full items-center gap-1 truncate rounded-full bg-background px-2.5 py-1 text-xs text-primary"
    onClick={onClick}
  >
    <BookOpen className="size-3 shrink-0" />
    <span className="truncate">{label ?? citationLabel(citation)}</span>
  </button>
)
